import React, {useEffect, useState} from 'react';
import {normalizeForSearch} from "../utils/search-utils.ts";
import {useStore} from "../utils/hooks.ts";
import {Language} from "../language/Language.ts";
import ReactDOM from "react-dom/client";
import {getLabel} from "../language/lang-utils.ts";
import GetLabel from "../language/GetLabel.tsx";
import {ssg, sss} from "../utils/common-utils.ts";

type SearchRules = {
    provinceEn: string,
    provinceFr: string,
    children: [
        {
            channelEn: string,
            channelFr: string,
            BDU: string
        }
    ],
    community: string | null
}

export const renderFormInYourArea = (div: string) => {
    const root = document.getElementById(div)
    if (root) {
        ReactDOM.createRoot(root).render(<React.StrictMode><InYourAreaSearch/></React.StrictMode>)
    }
}

export const InYourAreaSearch = () => {

    const store = useStore();
    const [searchRules, setSearchRules] = useState<SearchRules[]>();
    const [searchTerm, setSearchTerm] = useState<string | undefined>();
    const [searchResult, setSearchResult] = useState<SearchRules[]>();
    const [searchTermDefaultLoaded, setSearchTermDefaultLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (!searchTermDefaultLoaded) {
            const community = ssg("community")
            if (community) {
                setSearchTerm(community as string);
                setSearchTermDefaultLoaded(true)
            }
        }
    }, [searchTermDefaultLoaded]);


    useEffect(() => {
        if (searchRules == null) {
            const div = document.getElementById("in-your-area-form");
            if (div != null) {
                const searchRulesResult = div.dataset["searchrules"]
                if (searchRulesResult) {
                    const searchRulesDecoded = atob(searchRulesResult)
                    if (searchRulesDecoded) {
                        setSearchRules(JSON.parse(searchRulesDecoded).response)
                    }
                }
            }
        }
    }, [searchRules]);

    useEffect(() => {
        if (searchRules && searchTermDefaultLoaded) {
            doSearch()
        }
    }, [searchRules, searchTermDefaultLoaded])

    const onSearchTermChange = (event: { target: { value: any; name: any; }; }) => {
        // @ts-ignore
        const {value, name} = event.target
        setSearchTerm(value);
        setSearchResult(undefined)
    }
    // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //     if (e.key === 'Enter' || e.key === 'Space') {
    //         doSearch()
    //     }
    // }

    const doSearch = () => {
        if (searchRules && searchTerm) {
            sss("community", searchTerm)
            const filtered = searchRules.filter((rule) => {
                if (rule.community !== null) {
                    rule.community = normalizeForSearch(rule.community);
                }
                return rule.community === normalizeForSearch(searchTerm as string)
            });
            setSearchResult(filtered);
        }
    }

    document.querySelectorAll("#in-your-area-holder .btn-cityFind").forEach(e => {
        if (e instanceof HTMLElement) {
            e.addEventListener('click', () => doSearch());
            e.addEventListener('keydown', (e) => {
                if(e.key === 'Enter' || e.key === 'Space') {
                    doSearch();
                }
            })
        }
    })

    const channelEnglish = (channel: string) => {
        return (
            <dl className="channel-en">
                {channel &&
                    <><dt className="inarea-text"><GetLabel name="ENGLISH"/></dt><dd className="inarea-channel">{channel}</dd></>
                }
            </dl>
        );
    }

    const channelFrench = (channel: string) => {
        return (
            <dl className="channel-fr">
                {channel &&
                    <><dt className="inarea-text"><GetLabel name="FRENCH"/></dt><dd className="inarea-channel">{channel}</dd></>
                }
            </dl>
        );
    }

    return (
        <div>
            <div className="inyour-area-bar">
                <input id="cpac-search" autoFocus type='search' className="cpac-area-input" placeholder={getLabel("CITY")} aria-label={getLabel("IN_YOUR_AREA_PAGE_DESCRIPTION")} onChange={onSearchTermChange} value={searchTerm ? searchTerm : ""}/>
                <button className="btn-cityFind"><GetLabel name="FIND"/></button>
            </div>
            <section className="inyour-area-search-results">
                {searchResult && searchResult.map((rule) => {
                    return <div key={rule.provinceEn} itemScope itemType='https://schema.org/ItemList'>
                        <h2 className="inyour-area-community" tabIndex={0}>
                            <span className="community-label">{searchTerm && getLabel("RESULTS_FOR")}</span> <span className="community-name">{searchTerm && searchTerm !== '' ? searchTerm + ', ' : ''}{store.lang == Language.en ? rule.provinceEn : rule.provinceFr}</span>
                        </h2>
                        {rule.children.map((child) => {

                            return <div className="company-item col" key={child.BDU} itemProp='itemListElement'>
                                <div>
                                    <h3 className="company-name">{child.BDU}</h3>
                                    <div className="in-area-grid">
                                        {store.lang == Language.en ? channelEnglish(child.channelEn) : channelFrench(child.channelFr)}
                                        {store.lang == Language.en ? channelFrench(child.channelFr) : channelEnglish(child.channelEn)}
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                })
                }
            </section>
        </div>
    )
}
